import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  constructor(
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit() {
    this.title.setTitle('About Talespinner.io - AI-Powered Storytelling Platform');
    this.meta.updateTag({ name: 'description', content: 'Learn about Talespinner.io, an AI-powered storytelling platform created by Vincent Bons. Discover our mission, technology, and join our community of writers.' });
    this.meta.updateTag({ name: 'keywords', content: 'Talespinner.io, AI storytelling, Vincent Bons, creative writing, machine learning, storytelling platform' });
  }
}
